import { createSession } from '../utils/jbSession';

let savedFuelApiRestHost = '';

export async function requestFuelApiHost() {
	return new Promise((resolve, reject) => {
		if (savedFuelApiRestHost != '') {
			resolve(savedFuelApiRestHost);
		} else {
			const connection = createSession();

			connection.on('requestedEndpoints', async (endpoints) => {
				// console.log(`requestedEndpoints is ${JSON.stringify(endpoints)}`);
				if (endpoints && endpoints.fuelapiRestHost) {
					savedFuelApiRestHost = endpoints.fuelapiRestHost;
					resolve(savedFuelApiRestHost);
				} else {
					reject('JB did not return a valid api rest host');
				}
			});

			connection.trigger('requestEndpoints');
		}
	});
}

export function setFuelApiRestHost(host) {
	savedFuelApiRestHost = host;
}